export default {
  ptoForGoodList: {
    results: [],
  },
  ptoForGoodOne: {},
  ptoStatesMini: []
}
